import moment from 'moment-timezone';

export function getInventoryName(isFakeSeated = false, inventory, timezone) {
    if (isFakeSeated && inventory.start_date) {
        return `${new Date(inventory.start_date).toLocaleDateString([], { timeZone: timezone })} - ${new Date(inventory.start_date).toLocaleTimeString([], {
            timeZone: timezone
        })}`;
    }
    return inventory.name;
}

export function computeQuota(ratesTree, quotasModel, event) {
    /**
     * This function is used to compute all quotas for Event/Session/Groups/Rates. Call this function after getting all models to
     * compute quotas once. We can have groups and sub group but below 2levels, this function must be refacto to create the dict
     * recursively.
     *
     * computedQuotas seems like :
     * 'root': {
     *     taken: 2
     *     available: 30
     *     'group 1': {
     *         taken: 2
     *         available: 10
     *         'sousGroup1': {
     *             taken: 2
     *             available: 5
     *             'tarif 1' : {
     *                 taken: 1
     *                 avalable: 5
     *             }
     *         },
     *         sousGroup2: {
     *             ...
     *         }
     *         "tarif 3" : {
     *             taken:
     *             avalable:
     *         }
     *     }
     * }
     */
    let computedQuotas = {};
    let eventQuota = quotasModel.filter(q => q.event_id !== 0 && q.rate_id === 0 && q.session_id === 0 && q.rate_group_id === 0);

    let sessionsQuotas = quotasModel.filter(q => q.event_id !== 0 && q.rate_id === 0 && q.session_id !== 0 && q.rate_group_id === 0);

    let groupsQuotas = quotasModel.filter(q => q.event_id !== 0 && q.rate_id === 0 && q.rate_group_id !== 0);

    let ratesQuotas = quotasModel.filter(q => q.event_id !== 0 && q.rate_id !== 0 && q.rate_group_id === 0);

    let rates = [];
    ratesTree.eachRate(rate => {
        rates.push(rate);
    });

    let groups = [];
    ratesTree.eachGroup(group => {
        groups.push(group);
    });

    // To keep groupQuotas list relative to rate's display order, and lacking the proper information within the quota modal. This list must be reorder to prevent missing datas.
    // In some cases, the parent group is located after or between it's children within the groupQuotas list, which causes the algorithm below to set wrong datas and then erase it, leaving only the subgroups that are located AFTER the main group. Thus breaking the page.
    let orderedGroupQuotas = [];
    groups.forEach(grp => {
        const quotasGroup = groupsQuotas.filter(g => g.rate_group_id === grp.id);
        if (quotasGroup) {
            orderedGroupQuotas = [...orderedGroupQuotas, ...quotasGroup];
        }
    });

    // Compute event quota
    computedQuotas[event.id.toString()] = {
        available: eventQuota.length && eventQuota[0].quota_total ? eventQuota[0].quota_total - eventQuota[0].quota_taken : Infinity,
        taken: 0
    };

    // Compute Session Quota into event quota
    if (sessionsQuotas.length) {
        sessionsQuotas.forEach(sessionQuota => {
            computedQuotas[sessionQuota.event_id.toString()][sessionQuota.session_id.toString()] = {
                available: sessionQuota.quota_total ? sessionQuota.quota_total - sessionQuota.quota_taken : Infinity,
                taken: 0
            };
        });
    }

    // Compute Group Quota into Session quota (if there is a session), into Event quota
    // Manage sub group
    if (orderedGroupQuotas.length) {
        orderedGroupQuotas.forEach(groupQuota => {
            let group = groups.find(g => g.id === groupQuota.rate_group_id);
            if (!group) {
                // Weez quota API send us all quotas, even from deleted groups
                return;
            }

            // Level correspond to basis of comptued quota. If we do not have session, it correspond to the level event.
            // if we have a session, level correspon to the 2nd level (event -> session).
            let level = computedQuotas[groupQuota.event_id.toString()];
            if (groupQuota.session_id) {
                level = computedQuotas[groupQuota.event_id.toString()][groupQuota.session_id.toString()];
            }

            if (!group.parent) {
                level[groupQuota.rate_group_id.toString()] = {
                    available: groupQuota.quota_total ? groupQuota.quota_total - groupQuota.quota_taken : Infinity,
                    taken: 0
                };
            } else {
                if (!Object.keys(level).includes(group.parent.toString())) {
                    // Sometimes child group arrives before parent group
                    level[group.parent.toString()] = [];
                }
                level[group.parent.toString()][groupQuota.rate_group_id.toString()] = {
                    available: groupQuota.quota_total ? groupQuota.quota_total - groupQuota.quota_taken : Infinity,
                    taken: 0
                };
            }
        });
    }

    if (ratesQuotas.length) {
        ratesQuotas.forEach(rateQuota => {
            // Rate without group useless to find the group of the rate into computedQuotas
            let r = rates.find(rate => rate.id === rateQuota.rate_id);
            if (!r) {
                // Weez quota API send us all quotas, even from deleted rates
                return;
            }
            let _quota = {
                available: rateQuota.quota_total ? rateQuota.quota_total - rateQuota.quota_taken : Infinity,
                taken: 0
            };

            // Level correspond to basis of comptued quota. If we do not have session, it correspond to the level event.
            // if we have a session, level correspon to the 2nd level (event -> session).
            // This system allows us to make reuse our code to compute quota, even if we have session.
            let level = computedQuotas[rateQuota.event_id.toString()];
            if (rateQuota.session_id) {
                level = computedQuotas[rateQuota.event_id.toString()][rateQuota.session_id.toString()];
            }

            if (!r.group) {
                // No session ID, Rate is level 2 (Event --> rate) of computedQuotas
                // session ID, Rate is level 3 (Event --> session --> rate) of computedQuotas
                level[rateQuota.rate_id.toString()] = { ..._quota };
            } else {
                let keyIndex = Object.keys(level).findIndex(key => key === r.group.toString());
                if (keyIndex >= 0) {
                    // Groupe has been found in this level, juste put the rate into it.
                    level[r.group.toString()][rateQuota.rate_id.toString()] = { ..._quota };
                } else {
                    // Search the group_id on 2nd level ( or 3rd is we have session) because we have not found it on 1st level ( or 2nd is we have session)
                    // Aim : Iterate on each Keys in computedQuotas[rateQuota.event_id] (mean we are iterating on rates_id(without group) and Groups_id)
                    // If we found a the group into one of groups, we store the key in parentGroupKey to put the rate into the group owned by the parentGroupKey
                    let parentGroupKey = null;
                    Object.keys(level)
                        .filter(key => !['available', 'taken'].includes(key))
                        .forEach(key => {
                            let keyIndex = Object.keys(level[key]).findIndex(key => key === r.group.toString());
                            if (keyIndex >= 0) {
                                parentGroupKey = key;
                            }
                        });
                    if (parentGroupKey) {
                        level[parentGroupKey][r.group.toString()][rateQuota.rate_id.toString()] = { ..._quota };
                    } else {
                        // This case should never happen
                    }
                }
            }
        });
    }

    return computedQuotas;
}

export function getUpdatedQuota(quotas, selectedSessions = [], selectedRates = []) {
    /**
     * Get selected rates given on onChangeRates, and increase/decrease quotas on each level.
     */

    let quotaTmp = Object.assign({}, quotas);

    // 1 - Get session
    let sessionId = null;
    if (selectedSessions.length) {
        sessionId = selectedSessions[0]['weez_date_id'];
    }

    // 2 - Get if our rate is in subgroup or not
    let currentQuota = {};
    let quantityToChange = 0;

    selectedRates.forEach(selectedRate => {
        let groupId = selectedRate.rate.group;
        let rateId = selectedRate.rate.id;
        let quantity = selectedRate.quantity;
        let eventId = selectedRate.rate.event;
        let parentGroupId = null;

        let level = quotaTmp[eventId];
        if (sessionId) {
            level = quotaTmp[eventId][sessionId];
        }
        if (groupId) {
            // If we have group, we have to know if it is a subgroup or not.
            if (!Object.keys(level).includes([groupId])) {
                // Group is a sub group
                Object.keys(level)
                    .filter(key => !['available', 'taken'].includes(key))
                    .forEach(key => {
                        if (Object.keys(level[key]).includes(groupId.toString())) {
                            parentGroupId = key;
                        }
                    });
            }
        }

        // 3 - Change quotas below
        if (groupId && parentGroupId) {
            // Our rate have group and sub group
            currentQuota = level[parentGroupId][groupId][rateId];
            quantityToChange = quantity - currentQuota['taken'];
            level[parentGroupId][groupId][rateId]['taken'] += quantityToChange;
            level[parentGroupId][groupId]['taken'] += quantityToChange;
            level[parentGroupId]['taken'] += quantityToChange;
        }
        if (groupId && !parentGroupId) {
            // Our rate have group but no sub group
            currentQuota = level[groupId][rateId];
            quantityToChange = quantity - currentQuota['taken'];
            level[groupId][rateId]['taken'] += quantityToChange;
            level[groupId]['taken'] += quantityToChange;
        }
        if (!groupId) {
            // our rate have no group
            currentQuota = level[rateId];
            quantityToChange = quantity - currentQuota['taken'];
            level[rateId]['taken'] += quantityToChange;
        }

        if (sessionId) {
            // If session ID change quotas taken
            quotaTmp[eventId][sessionId]['taken'] += quantityToChange;
        }

        // Change quota taken of event
        quotaTmp[eventId]['taken'] += quantityToChange;
    });

    return quotaTmp;
}

export function getQuotaByRate(rateId, groupId = null, sessionId = null, quota, event) {
    /**
     * Search rate into the dict of multi level named quotas.
     *
     * return the quota available - taken on each level
     */
    let group_quota = Infinity;
    let parent_group_quota = Infinity;
    let event_quota = quota[event.id.toString()]['available'] - quota[event.id.toString()]['taken'];
    let rate_quota = Infinity;
    let session_quota = Infinity;

    let level = quota[event.id.toString()];

    if (sessionId) {
        if (level[sessionId.toString()]) {
            //Check if the session exist
            level = level[sessionId.toString()];
            session_quota = level['available'] - level['taken'];
        } else {
            return { rate_quota: rate_quota, event_quota: event_quota, group_quota: group_quota, session_quota: 0 };
        }
    }

    if (!groupId) {
        // Without group, All information in on the 2nd level (Event -> Rate)
        rate_quota = level[rateId.toString()]['available'] - level[rateId.toString()]['taken'];
        return { rate_quota: rate_quota, event_quota: event_quota, group_quota: group_quota, session_quota: session_quota };
    }

    if (Object.keys(level).includes(groupId.toString())) {
        // Here we have groups AND the group id has been found on the 2nd level, so our information is on 3rd level (Event->Group->Rate)
        rate_quota = level[groupId.toString()][rateId.toString()]['available'] - level[groupId.toString()][rateId.toString()]['taken'];
        group_quota = level[groupId.toString()]['available'] - level[groupId.toString()]['taken'];
        return { rate_quota: rate_quota, event_quota: event_quota, group_quota: group_quota, session_quota: session_quota };
    } else {
        // Our group has not been found on the 2nd level, we are in Sub-Group, our information is on 4th level (Event -> Group -> subGroup -> Rate)
        Object.keys(level)
            .filter(key => !['available', 'taken'].includes(key))
            .forEach(key => {
                if (Object.keys(level[key]).includes(groupId.toString())) {
                    rate_quota = level[key][groupId.toString()][rateId.toString()]['available'] - level[key][groupId.toString()][rateId.toString()]['taken'];
                    group_quota = level[key][groupId.toString()]['available'] - level[key][groupId.toString()]['taken'];
                    parent_group_quota = level[key]['available'] - level[key]['taken'];
                }
            });
        return { rate_quota: rate_quota, event_quota: event_quota, group_quota: group_quota, session_quota: session_quota, parent_group_quota: parent_group_quota };
    }
}

export function formateRates(computedQuota, ratesTree, sessionTree = [], searchRateIntoQuota = () => {}) {
    /**
     * Construct rates and add 2 informations on each rates :
     *  - quota_details : correspond to quotas currently available on each level (session/event/rate/group/subgroup)
     *  - active : is rate is available
     */
    const now = moment()._d.toISOString();
    let all_rates = [];
    if (Object.keys(computedQuota).length) {
        let rates = [];
        ratesTree.eachRate(rate => {
            if (rate.fees.length >= 1 && rate.price) {
                rate.price = null;
                let totalFrees = rate.fees.reduce((accumulator, frais) => accumulator + Number(frais.amount), 0);
                let newRateWithFees = parseFloat(rate.original_object.price) + parseFloat(totalFrees);
                rate.price = newRateWithFees;
            }
            rates.push(rate);
        });

        if (sessionTree) {
            sessionTree.forEach(session => {
                session.rates.forEach(sessionRate => {
                    let rate = rates.find(r => r.id === sessionRate.rate_id);
                    rate.quotas_details = searchRateIntoQuota({ rateId: rate.id, groupId: rate.group, sessionId: session.weez_date_id });
                    if (!rate.visibility_end_date || rate.visibility_end_date === null || rate.visibility_end_date > now) {
                        rate.active = true;
                    } else if (rate.visibility_end_date && rate.visibility_end_date < now) {
                        rate.active = false;
                    }

                    let _rate = rate.copy();
                    _rate.sessionId = session.uuid;
                    all_rates.push(_rate);
                });
            });
        } else {
            rates.forEach(rate => {
                rate.quotas_details = searchRateIntoQuota({ rateId: rate.id, groupId: rate.group, sessionId: null });
                if (!rate.visibility_end_date || rate.visibility_end_date === null || rate.visibility_end_date > now) {
                    rate.active = true;
                } else if (rate.visibility_end_date && rate.visibility_end_date < now) {
                    rate.active = false;
                }

                all_rates.push(rate);
            });
        }
    }
    return all_rates;
}
